type Callback = (payload?: any) => void;

class EventEmitter {
  private events: { [key: string]: Callback[] } = {};

  on(event: string, listener: Callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }

  off(event: string, listener: Callback) {
    if (!this.events[event]) return;

    this.events[event] = this.events[event].filter((l) => l !== listener);
  }

  emit(event: string, payload?: any) {
    if (!this.events[event]) return;

    this.events[event].forEach((listener) => listener(payload));
  }
}

export const eventEmitter = new EventEmitter();
